// extracted by mini-css-extract-plugin
export default {"title":"HaltedSymbol_title__c--ys","contentWrapper":"HaltedSymbol_contentWrapper__y0V+a"};